import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseService {
  protected constructor() {
    super('Email');
  }

  emailReport(to: string, pdfOutput: string): Observable<any> {
    return this.httpService.postForText(`${this.apiUrl}/EmailReport/${encodeURIComponent(to)}`, pdfOutput);
  }

  emailReportWithSellingCompany(
    email: string,
    ccEmail: string,
    subject: string,
    emailBody: string,
    // FormData containing the report PDF (was mistyped as string — the legacy
    // jsPDF path passed FormData through an `any` return type)
    pdfOutput: FormData,
    sellingCompany: string,
    attachDocuments: boolean,
    type: string,
    key: string,
  ): Observable<any> {
    return this.httpService.postForText(
      `${this.apiUrl}/EmailReportWithSellingCompany/${encodeURIComponent(email)}/${encodeURIComponent(ccEmail ?? ' ')}/${encodeURIComponent(subject)}/${btoa(unescape(encodeURIComponent(emailBody)))}/${attachDocuments}/${type}/${key}/${sellingCompany}`,
      pdfOutput,
    );
  }
}
